import { Injectable } from "@angular/core";
import { AlertController } from "@ionic/angular";
import { TranslocoService } from "@ngneat/transloco";
import { ApiService } from "../../../configuration/services/api.service";
import { RideOpsUiService } from "../../../configuration/services/rideops-ui.service";
import { LocationStateQuery } from "../../../configuration/state/location-state.query";
import { LocationStateService } from "../../../configuration/state/location-state.service";

@Injectable({ providedIn: "root" })
export class OpenLocationGuardService {
	constructor(
		private locationStateQuery: LocationStateQuery,
		private locationStateService: LocationStateService,
		private apiService: ApiService,
		private alertController: AlertController,
		private translocoService: TranslocoService,
		private rideOpsUi: RideOpsUiService,
	) {}

	allowOpeningLocation = async (): Promise<boolean> => {
		const location = await this.locationStateQuery.location$.firstAsync();
		await this.locationStateService.updateLocationStatus(location.id);
		const isClearedForOperation = await this.locationStateQuery.isClearedForOperation$.firstAsync();

		if (!isClearedForOperation) {
			return false;
		}

		const criticalResults = await this.apiService.getCriticalResults();
		const hasMaintenanceCheckMessage =
			!!(await this.locationStateQuery.messageForOperatorWhenNoCriticalForOperationChecklistsPlanned$.firstAsync());
		const showMaintenanceCheckWarning = criticalResults.length === 0 && !hasMaintenanceCheckMessage;

		return !showMaintenanceCheckWarning || (await this.disregardMaintenanceCheckWarning());
	};

	private disregardMaintenanceCheckWarning = async (): Promise<boolean> => {
		const alert = await this.alertController.create({
			header: this.translocoService.translate("OPEN_LOCATION__NO_SCHEDULED_CFO_CHECKS_ALERT_TITLE"),
			message: this.translocoService.translate("OPEN_LOCATION__NO_SCHEDULED_CFO_CHECKS_ALERT_DESCRIPTION"),
			cssClass: this.rideOpsUi.isV2Active()
				? "operators-v2-dialog maintenance-warning-modal"
				: "maintenance-warning-modal",
			buttons: [
				{
					text: this.translocoService.translate("OPEN_LOCATION__NO_SCHEDULED_CFO_CHECKS_ALERT_CANCEL"),
					role: "cancel",
				},
				{
					text: this.translocoService.translate("OPEN_LOCATION__NO_SCHEDULED_CFO_CHECKS_ALERT_OK"),
					role: "ok",
				},
			],
		});

		await alert.present();
		const alertResult = await alert.onDidDismiss();

		return alertResult.role === "ok";
	};
}
